export default function WorkshopFlow() {
  const timeline = [
    {
      label: 'Morning Session',
      title: 'Hands-on tech and dance components in a supportive, non-competitive environment',
      icon: 'ri-sun-line',
      color: 'from-amber-400 to-orange-500'
    },
    {
      label: 'Team Activities',
      title: 'Focus on team synergy, communication and cross-departmental collaboration',
      icon: 'ri-team-line',
      color: 'from-cyan-400 to-blue-500'
    },
    {
      label: 'Afternoon Session',
      title: 'Collaborative missions that enhance group dynamics',
      icon: 'ri-compass-3-line',
      color: 'from-green-400 to-emerald-500'
    },
    {
      label: 'Live Streaming &amp; Digital Rewards',
      title: 'Digital rewards and live elements that enhance the sense of occasion and achievement',
      icon: 'ri-trophy-line',
      color: 'from-purple-400 to-pink-500'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-[#0D1B2A] to-black relative overflow-hidden">
      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(0,217,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,217,255,0.3) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <h2 className="text-5xl md:text-6xl font-bold text-white text-center mb-4">
          How the Elemental Harmony Workshop Works
        </h2>
        <div className="w-32 h-0.5 bg-cyan-400 mx-auto mb-20"></div>

        <div className="relative">
          {/* Timeline Spine */}
          <div className="absolute left-0 md:left-20 top-8 bottom-8 w-1 bg-cyan-400/30"></div>

          <div className="space-y-24">
            {timeline.map((item, index) => (
              <div key={index} className="relative flex items-start gap-8 md:gap-16">
                {/* Node Indicator */}
                <div className={`relative z-10 w-10 h-10 md:ml-16 rounded-full bg-gradient-to-br ${item.color} flex items-center justify-center flex-shrink-0 shadow-lg`}>
                  <i className={`${item.icon} text-white text-xl`}></i>
                </div>

                {/* Content Card */}
                <div className="flex-1 bg-[#16213E] rounded-2xl p-8 border-l-4 border-cyan-400 hover:shadow-2xl hover:shadow-cyan-500/20 transition-all group">
                  <div className="inline-block px-4 py-1 bg-orange-500/20 text-orange-400 text-sm font-semibold rounded-full mb-4">
                    {item.label}
                  </div>
                  <p className="text-white text-xl md:text-2xl leading-relaxed">
                    {item.title}
                  </p>
                </div>

                {/* Connecting Dashed Line */}
                <div className="hidden md:block absolute left-20 top-5 w-12 border-t-2 border-dashed border-cyan-400/40"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center bg-gradient-to-r from-cyan-500/10 to-blue-500/10 rounded-3xl p-10 border border-cyan-500/20">
          <p className="text-xl text-gray-300 leading-relaxed">
            <i className="ri-information-line text-cyan-400 text-2xl mr-2"></i>
            The workshop serves as a pre-competition experience, allowing employees to explore Groove &amp; Glow in a supportive environment.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Schedule Your Workshop
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
